import { onErrorResumeNextStatic } from '../operators/onErrorResumeNext';
export var onErrorResumeNext = onErrorResumeNextStatic;
//# sourceMappingURL=onErrorResumeNext.js.map